// @flow
import envConfig from '../../configs/envConfig';
import { retryFailedCns } from '../../components/containers/bulkCnUsingExcel/bulkCnUsingExcelRedux/bulkCnUsingExcelActionCreator';
import { addAttachment } from '../../components/containers/cms/cmsRedux/cmsActionCreator';

export const zoomConstants = {
  sessionUser: '/sessionUser',
  getDashboardUrl: '/getUrl',
  logout: '/oauth/revoke/authToken',
  getCollectionsCashbook: '/operations/retail/collections/cashbook',
  getCollectionsSummary: '/operations/retail/collections/summary',
  getCollectionsHandover: '/operations/retail/collections/handover',
  makeEditPaymentCall: '/operations/retail/paymentTypeDetails/v2',
  tdsApplicable: '/operations/retail/tds-applicable',
  getBankDetails: '/master/bank?status=ACTIVE',
  getRivigoBankDetails: '/master/bank-account',
  getCnWiseHandoverDetails: '/operations/retail/collections/pending',
  getOverallOutstanding: '/operations/retail/ouOutstanding',
  initiateHandover: '/operations/retail/collections/initiatehandover',
  uploadHandoverFile: '/operations/pay-near/upload',
  getHandoverFileTemplate: '/operations/pay-near/sample',
  getConsignmentById: '/operations/consignments/{id}',
  getCnoteDetails: '/operations/consignments/cnote/#cnote',
  ccGetUserClients: '/notification-user/search/user',
  ccGetDefaultUserSettings: '/notification-user/default',
  ccGetClientUserList: '/notification-user/search/name/clientId',
  ccEditNotificationsUser: '/notification-user/id',
  ccAddNotificationsUser: '/notification-user/',
  getTicketTypes: '/tickettype/keyval',
  getTicketTypeDetail: '/tickettype/detail',
  createTicketSubmit: '/ticket',
  editTicketSubmit: '/ticket/complete',
  getTicketDetails: '/ticket/detail',
  sendComments: '/comment',
  sendTicketEscalation: '/ticket/escalate',
  getTicketsHistory: '/ticket/history',
  getTicketsCount: '/ticket/count',
  getAssignedTickets: '/ticket/assigned',
  getUnassignedTickets: '/ticket/unassigned',
  getCreatedTickets: '/ticket/created',
  getAllTickets: '/ticket/all',
  checkEWayBillValidity: '/e-waybill/ticket/#ticketId/check',
  getCnoteInfo: '/zoomapi/cnoteinfo',
  getPrqInfo: '/zoomapi/prqinfo',
  getAssigneeOptions: '/autoassignsuggestion/search',
  getUserInfoFromEmail: '/user/email',
  getUserInfoFromMobile: '/user/mobile',
  putEditTicketChanges: '/ticket',
  putAssignToMe: '/ticket/assigntome/ticketId',
  getClientCodeOptions: '/zoomapi/searchclient',
  getTicketsSearch: '/ticket/search',
  getClusterLocationMapping: '/zoomapi/reportinglocations',
  getTicketStatusOptions: '/ticket/status',
  validateEWaybillNumber:
    '/e-waybill/#ewaybillNumber/validate/?cnote=#cnote&from-pincode=#from-pincode',
  consignmentQc: '/operations/consignments/qc',
  ticketingUserGroup: '/group/checkuser/',
  pincodeDetails: '/master/pincode/{pincode}',
  getClientsMis: '/master/client',
  getClientCodes: '/master/client/codes',
  getClients: '/master/client/search',
  getServiceTypeLane: '/service-type/lane',
  getServiceCategoryToServiceTypeMap: '/service-type/lane/service-category',
  getCustomClients: '/master/client/basis-user-type',
  getClientsByUser: '/master/client_user/clients/search',
  getClientByUserMis: '/master/client_user/clients',
  clientAddress: '/master/client_address',
  getLocalityByPincode: '/master/locality/getLocalityByPincode',
  getTimeSlots: '/operations/pickup/getTimeSlots',
  getSuggestedCaptains: '/operations/pickup/getCaptainSuggestions',
  edd: '/operations/consignments/estimateDeliveryTime',
  pickup: '/operations/pickup',
  getpickup: '/operations/pickup/{id}',
  existingPickups: '/operations/lite/pickup/clientExistingPickup',
  clientAddressV2: '/master/client_address/v2',
  pickupDashboardLiteV2: '/operations/lite/pickup/mis/V2',
  getLocations: '/master/location',
  getLocationByCode: '/master/location/locationCode',
  pickupfailurereasons: '/operations/dp/pickupFailureReasons/new',
  deletepickup: '/operations/pickup/cancel/V2',
  hierarchybelowadministrative:
    '/master/administrativeentity/hierarchybelowadministrative',
  pickupuser: '/master/user/pickupUser',
  reportinglocations: '/master/location/reporting',
  reportingclusters: '/master/administrativeentity/cluster',
  getAllHigherFloorVasEntity: '/operations/cetaskboard/higherFloorVas',
  changeHigherFloorVasStatus: '/operations/cetaskboard/higherFloorVas/{status}',
  bulkUploadHigherFloorVas:
    '/operations/cetaskboard/higherFloorVas/bulkUpdateFloor',
  pickuptracking: '/operations/pickup/track/{searchpickupid}',
  // Zoom-Wms apis
  cellMasterData: '/cell-master',
  createCellDtoListWithoutSave: '/cell/generate',
  getPrefixList: '/cell/prefixes',
  getAllZoneTypes: '/zone-type',
  getActiveZonebyType: '/zone/type',
  updateZoneDetails: '/zone',
  enableDisableShopfloor: '/utils/status/update',
  getShopfloorStatus: '/utils/status',
  editZonePresence: '/zone/status/#zoneTypeId',
  getLaneContents: '/utils/zone-contents',
  getCellPrefixes: '/cell/prefixes',
  getCellList: '/cell',
  getDepositSlipDetailsForCreations: '/deposit-slip/for-creation',
  printDepositSlipDetails: '/deposit-slip',
  getDepositSlipDetails: '/deposit-slip/all',
  searchDepositSlipDetails: '/deposit-slip/search',
  getDepositSlipDetailsForModal: '/deposit-slip/{id}',
  cancelDepositSlip: '/deposit-slip/cancel/{id}',
  bankSlip: '/deposit-slip/bank-slip',
  networkDashboard: '/network/NLH',
  getNetworkDefaultConfigs: '/network/NLH/getDefaultConfigs',
  networkDagActions: '/network/NLH/dag/{configId}',
  networkRunConfiguration: '/network/NLH/createUpdateConfig',
  getNetworkConfig: '/network/NLH/getConfig/{configId}',
  networkSupersetDashboard: '/superset/dashboard/network-tool/',
  initiateWriteOff: '/operations/retail/collections/writeOff/initiate',
  getAllowedPaymentTypes: '/payment-type',
  bpTransactions: '/zb/bp/transaction',
  bpSummary: '/zb/bp/summary',
  bpBalance: '/zb/bp/balance',
  bpTransactionsDownload: '/zb/bp/transaction/download',
  createQcTicket: '/operations/consignments/qc/manual/createQcMeasurement',
  createBulkCn: '/operations/booking',
  downloadBulkCn: '/tool/bulCnTool',
  pincodeDetailsInternal: '/serviceable/pincode/internal/{pincode}/{type}',
  pincodeFromToPairDetails: '/serviceable/pincode/internal/from/{from}/to/{to}',
  pincodeDetailsExternal: '/serviceable/pincode/external/{pincode}/{type}',
  pincodeDetailsViaClientCode: '/serviceable/pincode/active',
  pincodeFromToPairDetailsExternal:
    '/serviceable/pincode/external/from/{from}/to/{to}',
  trackBulk: '/tracking/v2/cnote/bulk/',
  tracking: 'trackconsignment/',
  crmCall: '/crm/call/details?uui=#uuid',
  crmInitiate: '/crm/call/initiate/#uuid',
  crmCallReasons: '/crm/call/reason',
  callStatusUpdate: '/crm/call/trigger/status',
  getReasons: '/master/reason/manual',
  getBlockedCnList: '/consignmentBlocker/byReasons',
  getUnblockedCns: '/consignmentBlocker/unblocked/consignments',
  blockCN: '/consignmentBlocker/blockUnblockAll',
  unblockCn: '/consignmentBlocker/bulkUnblockCn',
  rtoDamageCn: '/operations/consignments/rto/damage/{cnote}',
  getIncompleteCnList: '/operations/lite/consignments/incomplete',
  getExpectedArrivalsCount: '/operations/pickup/expectedConsignments',
  consignmentsAppointment: '/operations/cetaskboard/appointment',
  getFcName: '/master/consignment-custom-field/fc-list',
  changeConsignmentsAppointmentStatus:
    '/operations/cetaskboard/appointment/status',
  markUnmarkDacc: '/operations/cetaskboard/mark-unmark-dacc',
  scheduleAppointment: '/operations/cetaskboard/appointment/schedule',
  createAppointment: '/operations/cetaskboard/appointment',
  getConsignmentAppointmentDetails:
    '/operations/cetaskboard/appointment/{cnote}',
  getConsignmentAppointmentSummary:
    '/operations/cetaskboard/appointment/pending/summary',
  bulkUploadAppointment: '/operations/cetaskboard/bulkappointment',
  appointmentSheetTemplate: '/operations/cetaskboard/appointmentTemplate',
  getPoDetailsByConsignmentId:
    '/operations/cetaskboard/appointment/custom-details',
  misDownloadExcel: '/operations/lite/pickup/mis/V2/download',
  pickupCnsDownload: '/operations/lite/pickup/cnsDownload',
  sendEmailForMis: '/operations/lite/pickup/mis/V2/email',
  sendOtp: '/sendotp',
  getPreviousAddresses:
    '/master/client_address/getAddressesOfPickupsAndConsignments',
  getpickupConfig: '/config/pickup',
  verifyOtp: '/chatbot/verifyLoginUserOTP',
  cnMapViewData: '/tracking/cnMapView',
  checkOaMobile: '/master/user/zoomUser/oa/new/{mobile}',
  getActiveFaujiVendor: '/contract/fauji/vendor/active',
  oaGetCreate: '/master/user/zoomUser/oa',
  oaPullAtOu: '/master/user/zoomUser/oa/pull/{userId}',
  deactivateOa: '/master/user/zoomUser/oa/{userId}',
  epodSendOtp: '/epod/resend-otp/{token}/',
  epodVerifyOtp: '/epod/verify-otp/{token}/',
  epodFormDetails: '/epod/form-details/{token}/',
  uploadEpodFile: '/epod/form-details/{token}/upload',
  vasChargesGetDashboard: '/vas/expense/fetch-list',
  vasUnionDetails: '/vas/expense/details',
  getVehicleTypes: '/master/vehicle/types',
  getTotalVasCharge: '/vas/expense/total-charge',
  uploadVasReceipt: '/vas/expense/upload/receipt',
  uploadVasEmail: '/vas/expense/upload/email',
  postVasData: '/vas/expense/upsert',
  retriggerOtp: '/epod/retrigger-otp/{token}',
  makeGetChequeNumberCall: '/payment-type/cheque/ocr',
  bulkCnCreateUsingExcel: '/tool/bulk/cn-creation',
  barcodesPrint: '/utils/barcodes/print',
  systemBarcodesPrint: '/utils/barcodes/print/system-generated',
  shortPaymentReasons: '/master/reason/short-payment',
  getUtrDetails: '/payment/bank-transfer/utr/{utrNo}',
  getAvailableTemplates: '/bulk-upload/format/available',
  downloadTemplate: '/bulk-upload/format/{templateId}/template',
  requestSummary: '/bulk-upload/request',
  bulkUploadCn: '/bulk-upload/upload',
  cnBarcodesPrint: '/bulk-upload/request/{requestId}/barcodes',
  downloadRequestFile: '/bulk-upload/request-file/{requestId}/excel',
  downloadResponseFile: '/bulk-upload/request/{requestId}/excel',
  manageVehiclesFetchVehicles: '/vehicle/operations/v2',
  manageVehicles: '/vehicle',
  manageVehiclesUploadImage: '/vehicle/upload-image',
  manageVehiclesUploadRc: '/vehicle/upload-rc',
  manageVehiclesGetVendorNames: '/master/feeder_vendor',
  retryFailedCns: '/bulk-upload/request/{requestId}/retry',
  downloadCnCopies: '/bulk-upload/request/{requestId}/bulkpdf',
  consignmentDocumentChecker: '/document/consignment',
  getDocumentcheckerFilters: '/document/consignment/filter-configs/docType',
  getDocumentCheckerDocuments: '/document/consignment/docType',
  initiatePayment: '/payment/online/initiate',
  cancelOnlinePayment: '/payment/online/cancel/?transactionId={transactionId}',
  checkOnlinePaymentStatus: '/payment/online/?transactionId={transactionId}',
  resendPaymentLink: '/payment/online/{transactionId}/resend',
  getHolidayDeliveryRequestData: '/operations/cetaskboard/holiday/request',
  approveHolidayDeliveryRequest:
    '/operations/cetaskboard/holiday/request/approval',
  rejectHolidayDeliveryRequest:
    '/operations/cetaskboard/holiday/request/rejection',
  bulkPincodeCheck: '/serviceable/pincode/external/bulkPincodeTat',
  getVehiclesDetails: '/vehicle/user',
  getUserType: '/user/userType',
  getOrganisationDetailsList: '/operations/organization',
  getOrganisationCodeForBfUser: '/user/bfUser',
  getTemplateListUsingOrganisationCode:
    '/bulk-upload/format/organisation/available',
  getLocationsUsingOrganisationId: '/master/location/orgId',
  requestSummaryUsingOrganisationCode: '/bulk-upload/org/request',
  getPreBooksCnsData: '/operations/consignments/prebook',
  submitPreBookCnsData: '/operations/consignments/prebook',
  getRecentPickups: '/operations/pickup/recent-pickups',
  faqHtml: '/faq/faq-html',
  trackPickup: '/pickuptracking/',
  getChartsDataNsl: '/performance/NSL',
  getClientsById: '/master/client_user/clients',
  getChartsDataNslBreakup: '/performance/NSL/breakup',
  getChartsDataBusinessOverView: '/performance/business-overview',
  getRPClientList: '/master/user/stockaccumulator/retail-partners',
  deliveryApproval: '/delivery/action/approval',
  deliveryApprovalAction:
    '/delivery/action?cnote={cnote}&isApproved={isApproved}',
  getPrsDrsForCostApproval:
    '/dashboard/cost-approval/{entityType}/{expenseType}',
  getConsignmetsForPrs: '/operations/pickupRunSheet/consignmentsById',
  getConsignmentsForDrs: '/operations/delivery/{drsId}',
  getHandlingCostComponents: '/dashboard/cost-approval/{expenseId}/components',
  prsDrsCostApprovalAction: '/dashboard/cost-approval/action',
  getRejectionReasons: '/master/reason/reason-type',
  getRPCollectionAmountBalance: '/vendor/collections/{expenseType}/balance',
  confirmRPCollectionFnf:
    '/vendor/collections/{expenseType}/fnf/?orgCode={orgCode}&amount={amount}',
  approveRPBPFnf: '/vendor/collections/{expenseType}/fnf-approve',
  getRPCollectionAmountBalanceAdmin:
    '/vendor/collections/{expenseType}/balance/?orgId={orgId}',
  getRPCollectionHandoverPendingData:
    '/vendor/collections/{expenseType}/handover/pending?fromDateTime={fromDateTime}&toDateTime={toDateTime}',
  getRPCollectionHandoverPendingDataAdmin:
    '/vendor/collections/{expenseType}/handover/pending?fromDateTime={fromDateTime}&toDateTime={toDateTime}&orgId={orgId}',
  getRPCollectionHandoverCompletedData:
    '/vendor/collections/{expenseType}/handover/complete?fromDateTime={fromDateTime}&toDateTime={toDateTime}',
  getRPCollectionHandoverCompletedDataAdmin:
    '/vendor/collections/{expenseType}/handover/complete?fromDateTime={fromDateTime}&toDateTime={toDateTime}&orgId={orgId}',
  downloadRPCollectionTransactionReport:
    '/vendor/collections/{expenseType}/report/download?fromDateTime={fromDateTime}&toDateTime={toDateTime}',
  downloadRPCollectionTransactionReportAdmin:
    '/vendor/collections/{expenseType}/report/download?fromDateTime={fromDateTime}&toDateTime={toDateTime}&orgId={orgId}',
  knockOffConsignment:
    '/vendor/collections/{expenseType}/knock-off?consignmentId={consignmentId}',
  knockOffConsignmentAdmin:
    '/vendor/collections/{expenseType}/knock-off?consignmentId={consignmentId}&orgId={orgId}',
  getDirectDeliveryCount:
    '/delivery/action/approval/count/?entityType=WITHOUT_DRS',
  bulkCnConverter: '/custom-file-converter/upload',
  airflowSubmitConsignments: '/operations/lr/scan',
  getRpList: '/vendor/collections/{expenseType}/list',
  createPartialDummyPrs:
    '/bulk-upload/create-partial-dummy-prs?requestId={requestId}',
  bulkDeliveryApprovalAction: '/delivery/action/bulk',
  bulkApproveOrRejectCeTaskDashBoard:
    '/operations/cetaskboard/bulk-appointment/status',
  getDamagePilferageBlockedCnList: '/consignmentBlocker/damagePilferage',
  getChargeReconciliation: '/charge-reconciliation/view',
  getSearchChargeReconciliation: '/charge-reconciliation/view/cnote',
  getAmountBreakdown: '/charge-reconciliation/view/component-detail',
  statusChargereReconciliation: '/charge-reconciliation/action/{ctaAction}',
  getCityByPincode: '/master/pincode/getCity/citycode/type',
  getClient: '/master/client/clientCode',
  getCityByPincode: '/master/pincode/getCity/citycode/type',
  frieghtEstimation: '/operations/retail/freight-estimation',
  getEmails: '/communication/fetch-emails',
  saveDraftEmail: '/communication/save-draft-email',
  sendEmail: '/communication/send-email',
  addAttachment: '/communication/add-attachment',
  deleteAttachment: '/communication/delete-attachment',
  getEmailSummary: '/communication/fetch-email-summary',
  downloadCSV:
    '/communication/recipient-summary?communicationId={communicationId}',
  getDetailedEmail:
    '/communication/fetch-detailed-email?communicationId={communicationId}',
  getDamagePilferageBlockedCnList: '/consignmentBlocker/damagePilferage',
  geAdHolidayDate: '/holiday/delivery/fetch-holiday',
  // tech support endpoints
  searchConsignmentByCnote: '/operations/consignments/cnote/search/{cnote}',
  getConsignmentCache: '/operations/clmPanel/consignmentcache/',
  // audit log
  audit: '/audit/base',
  auditTables: '/audit/base/tables'
};

const getUrlParams = replaceParamsArr => {
  // eg: replaceParamsArr = [{key:"abc", val:123}, {key:"abcd", val:1234} ]
  if (!replaceParamsArr || replaceParamsArr.length === 0) {
    return null;
  }
  let paramUrlString = '';
  let separator;
  const eqString = '=';
  replaceParamsArr.map(item => {
    separator = paramUrlString.indexOf('?') === -1 ? '?' : '&';
    paramUrlString +=
      item.val ||
      typeof item.val === 'string' ||
      typeof item.val === 'number' ||
      typeof item.val === 'boolean'
        ? separator + item.key + eqString + item.val
        : '';
    return item; // returning item just to avoid eslint error
  });
  return paramUrlString;
};

const getUrlWithPathVariables = (url, pathVariables) => {
  pathVariables.map(item => {
    url = url.replace(item.key, item.val);
    return item; // returning just for eslint
  });
  return url;
};

export const generateApiUrl = apiCallObj => {
  let url =
    envConfig[apiCallObj.baseUrl] + zoomConstants[apiCallObj.apiEndPoint];
  if (apiCallObj.replaceParamsArr) {
    url += getUrlParams(apiCallObj.replaceParamsArr);
  }
  if (apiCallObj.params) {
    let paramsArray = [];
    const paramsArrayFromObjectKeys = Object.keys(apiCallObj.params);
    paramsArray = paramsArrayFromObjectKeys.map(item => ({
      key: item,
      val: apiCallObj.params[item]
    }));
    url += getUrlParams(paramsArray);
  }
  if (apiCallObj.pathVariables) {
    url = getUrlWithPathVariables(url, apiCallObj.pathVariables);
  }
  return url;
};
